import { InstallationPredictedStatusEnum } from "@/model/data/predictiveMaintenance/InstallationPredictedStatusEnum";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { Reject } from "@/model/data/logAnalysis/Reject";

export class GetMachineRejectsResData extends ApiGenericResponse {
    rejects: Reject[];
    rejectsCause: Map<string, string>;
    rejectsFamily: Map<string, string>;
    familyLabel: Map<string, string>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Rejects) {
            this.rejects = new Array();
            obj.Rejects.forEach((element) => {
                let reject = new Reject();
                reject.parse(element);
                this.rejects.push(reject);
            });
        }

        if (obj.RejectsCause) {
            this.rejectsCause = obj.RejectsCause;
        }
        if (obj.RejectsFamily) {
            this.rejectsFamily = new Map<string, string>(Object.entries(obj.RejectsFamily));
        }
        if (obj.FamilyLabel) {
            this.familyLabel = new Map<string, string>(Object.entries(obj.FamilyLabel));
        }
    }
}
